import type { ReactNode } from "react";

interface SignalsCardProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
}

export function SignalsCard({
  title,
  subtitle,
  action,
  children,
  className = "",
}: SignalsCardProps) {
  return (
    <section
      className={`bg-card overflow-hidden rounded-lg border ${className}`}
    >
      <header className="flex items-start justify-between gap-3 border-b px-4 py-3">
        <div>
          <h2 className="text-foreground text-sm font-semibold">{title}</h2>
          {subtitle && (
            <p className="text-muted-foreground mt-0.5 text-xs">{subtitle}</p>
          )}
        </div>
        {action}
      </header>
      {children}
    </section>
  );
}

/** A headline figure. With `onSelect` it becomes a button that drills through. */
export function StatTile({
  label,
  value,
  hint,
  onSelect,
}: {
  label: string;
  value: string;
  hint?: string;
  onSelect?: () => void;
}) {
  const body = (
    <>
      <p className="text-muted-foreground text-xs font-medium">{label}</p>
      <p className="text-foreground mt-1 text-2xl font-semibold">{value}</p>
      {hint && <p className="text-subtle-foreground mt-0.5 text-xs">{hint}</p>}
    </>
  );

  if (!onSelect) {
    return <div className="bg-card rounded-lg border p-4">{body}</div>;
  }

  return (
    <button
      type="button"
      className="bg-card hover:border-muted-foreground/40 hover:bg-muted cursor-pointer rounded-lg border p-4 text-left"
      onClick={onSelect}
    >
      {body}
    </button>
  );
}

export function EmptyState({ message }: { message: string }) {
  return (
    <div className="text-subtle-foreground px-4 py-8 text-center text-sm">
      {message}
    </div>
  );
}
